import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class SchoolCourseDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
				  <p>MIET wants to set a new benchmark in education with teaching standards, exceptional faculties and innovative programmes. With the vision to educate, MIET provides classes for IX, X, XI & XII students who aspire to complete them with ease. MIET guides its students from hardships of understanding the concepts and helps study better with tips and tricks. It also envisions the struggles of every student who wish to clear their boards with no difficulties by conducting mock tests and extra guidance with rich study materials to pass with successful colors.</p>
				  
                  </ScrollAnimation>
                  
					<ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
							
                            <p><b>Boards Covered:</b> CBSE, STATE, IGCSE</p>
                            <p><b>Class :</b>  IX, X , XI, XII</p>
                            <p><b>Mode of classes :</b>  Offline & Online </p>
                            <p><b>Batches :</b> Evening & Weekend</p>
							
						</blockquote>
					</div>
					</ScrollAnimation>		
					<ScrollAnimation animateIn="fadeInRight">
				  	<div className='blog-details-page-content'>
					<blockquote>
						<h5 className="mb-0 mt-2">Application Form:</h5><br/>
						<Link to="/online-payment"><button className="btn btn-base" style={{color:'white',fontWeight:'700'}}>Visit</button></Link>
					</blockquote>
					</div>
					</ScrollAnimation>			
				  </div>
		      </div>
			  <Sidebar courseRestriction="Classes (IX, X, XI, XII)"/>
		    </div>
		  </div>
		</div>

        }
}

export default SchoolCourseDetails